import * as React from 'react'
import {
  Box,
  Container,
  Typography,
  useMediaQuery,
  useTheme,
} from '@material-ui/core'
import {
  HeroSection,
  LinkWithIcon,
  ProductInfoVariationForty,
  ProductInfoVariationHundred,
  ProductInfoVariationSeventy,
  ProductInfoVariationSixty,
  PromoItem,
  Slash,
  XRayText,
} from '../../components'
import { contentfulArrayToObject, getDescription } from '../../utils/cms'
import { useStyles } from './fleetFinancingView.styles'
import { useHeroStyles } from '../home/Home.styles'
import { SLASH_HEIGHT } from '../../constants'
import { productFeaturesData } from './productFeaturesData'
import ProductInfoVariationThirtyFleetFinancing from '../../components/ProductInfo/ProudctInfoVariation30FleetFinancing'

const FleetFinancingView = ({
  t,
  language,
  footerNode,
  data = {},
  ...props
}) => {
  const styles = useStyles()
  const theme = useTheme()

  const slashHeight = SLASH_HEIGHT

  const newHeight = useMediaQuery(theme.breakpoints.down('sm'))
    ? slashHeight * 0.5
    : slashHeight
  const slashMaxGrowth = footerNode?.clientHeight / newHeight

  const { sections } = data
  const {
    ContentfulHeroSection: hero,
    ContentfulSectionText: section,
    ContentfulHomepageServices: services,
    ContentfulImageAnimation: imageAnimation,
  } = contentfulArrayToObject(sections)

  const { image: imageAnimationImage } = imageAnimation || {}
  const imageUrl = imageAnimationImage?.file?.url
  const imageContentType = imageAnimationImage?.file?.contentType

  return (
    <>
      <main className={styles.root}>
        <Slash
          stopGrowingPositionYOffset={footerNode?.clientHeight / 3}
          startGrowingPositionYOffset={footerNode?.clientHeight * 2.5}
          height={newHeight}
          growthScale={{ initial: 1, target: slashMaxGrowth }}
        />
        {/* Hero Section */}
        {hero && (
          <HeroSection
            homepage
            t={t}
            {...hero}
            useCustomStyles={useHeroStyles}
          />
        )}

        {/* Video Section */}
        {imageAnimation && (
          <Box className={styles.videoContainer}>
            {imageUrl && (
              <video
                className={styles.video}
                loop
                autoPlay={true}
                muted={true}
                playsInline={true}
              >
                <source src={imageUrl} type={imageContentType} />
              </video>
            )}
          </Box>
        )}

        {/* Services Section */}
        {services && (
          <Container maxWidth="lg">
            {(Array.isArray(services) ? services : [services]).map(
              (
                {
                  imageToRight,
                  serviceHeading,
                  serviceDescription,
                  serviceImages,
                  serviceCta,
                  fallbackUrl,
                },
                index,
              ) => (
                <PromoItem
                  key={`fleet-service-${index}`}
                  reverse={!imageToRight}
                  title={serviceHeading}
                  description={getDescription(serviceDescription?.raw || '')}
                  animationPath={
                    serviceImages
                      ? serviceImages[0]?.image?.file.url
                      : undefined
                  }
                  placeholderPath={
                    serviceImages ? serviceImages[0]?.bucketUrl : fallbackUrl
                  }
                  cta={serviceCta}
                />
              ),
            )}
          </Container>
        )}

        {/* Section Text */}
        {section && (
          <Box>
            <Container maxWidth="md">
              <Box className={styles.section}>
                <XRayText
                  variant="h3"
                  content={section.title}
                  textClass={styles.sectionHeading}
                />
                <Typography
                  className={styles.sectionDescription}
                  variant="body1"
                >
                  {getDescription(section.sectionText.raw)}
                </Typography>
                {section.link ? (
                  <LinkWithIcon
                    className={styles.sectionLink}
                    {...section.link}
                  />
                ) : null}
              </Box>
            </Container>
          </Box>
        )}
        {props.productFeatureType && (
          <Container maxWidth="md" className={styles.productInfoContainer}>
            {productFeaturesData[props.productFeatureType].map((feature) => {
              switch (feature.type) {
                case 'THIRTY':
                  return (
                    <ProductInfoVariationThirtyFleetFinancing
                      {...feature}
                      t={t}
                    />
                  )
                case 'FORTY':
                  return <ProductInfoVariationForty {...feature} t={t} />
                case 'SIXTY':
                  return <ProductInfoVariationSixty {...feature} t={t} />
                case 'SEVENTY':
                  return <ProductInfoVariationSeventy {...feature} t={t} />
                case 'HUNDRED':
                  return <ProductInfoVariationHundred {...feature} t={t} />
                default:
                  return null
              }
            })}
          </Container>
        )}
      </main>
    </>
  )
}

export default FleetFinancingView
